export default {"src":"/_next/static/media/Check.86b406e5.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};